module.exports = __webpack_public_path__ + "media/images/common/menu_coop_aichi-e2edea6d923025890d08c5d97f68e69c.png";